import DRX_BRAND from "@icons/drx-logo.svg";
import "./style.scss";

const Header = () => {
  return (
    <div className="header-wrapper">
      <img src={DRX_BRAND} alt="drx-brand" />
    </div>
  );
};

export default Header;
